import styled, { css } from 'styled-components';
import { colors, fontFamily } from '../../../Utils/tokens';

export const MoreButton = styled.button<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;

  img {
    display: block;
    width: 16px;
    height: 16px;
  }
`;

export const ItemContainer = styled.div<{ $selected: boolean; $menuOpen: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 28px;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: ${colors.secondary};
    `}

  ${({ $menuOpen }) =>
    $menuOpen &&
    css`
      background-color: ${colors.onSurfaceHover};
    `}

  &:hover,
  &:focus-visible,
  &:has(:focus-visible) {
    outline: none;
    background-color: ${colors.onSurfaceHover};

    ${MoreButton} {
      display: flex;
    }
  }
`;

const itemText = css`
  flex: 1 0 0;
  min-width: 0;
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${colors.onSurface};
`;

export const ItemTitle = styled.span`
  ${itemText};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RenameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 28px;
  padding: 5px;
  border: 1px solid ${colors.primary};
  border-radius: 6px;
  background-color: ${colors.surface};
`;

export const RenameInput = styled.input`
  ${itemText};
  width: 100%;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
`;
